export function getTileValue(tile) {
  return typeof tile === 'object' && tile !== null ? tile.value : tile;
}

export function canPlaceOnStack(stack, value) {
  const top = stack.length === 0 ? 0 : getTileValue(stack[stack.length - 1]);
  return top === 0 ? getTileValue(value) === 1 : top + 1 === getTileValue(value);
}

export function applyMoveToBoard(state, targetType, targetIndex, value) {
  if (targetType === 'column') {
    return state.map((entry, idx) => (idx === targetIndex ? [...entry, value] : entry));
  }
  if (!canPlaceOnStack(state[targetIndex], value)) return null;
  return state.map((entry, idx) => (idx === targetIndex ? [...entry, value] : entry));
}

export function cloneBoard(board) {
  return board.map((col) => [...col]);
}

export function sweepStacks(columnsInput, stacksInput) {
  const columns = cloneBoard(columnsInput);
  const stacks = cloneBoard(stacksInput);
  let moved = true;
  let movedCount = 0;

  while (moved) {
    moved = false;
    for (let stackIndex = 0; stackIndex < stacks.length; stackIndex += 1) {
      const stackTop = stacks[stackIndex].length
        ? getTileValue(stacks[stackIndex][stacks[stackIndex].length - 1])
        : 0;
      const needed = stackTop + 1;
      if (needed > 13) continue;

      const sourceColumnIndex = columns.findIndex(
        (col) => col.length > 0 && getTileValue(col[col.length - 1]) === needed
      );
      if (sourceColumnIndex >= 0) {
        const value = columns[sourceColumnIndex].pop();
        stacks[stackIndex].push(value);
        movedCount += 1;
        moved = true;
      }
    }
  }

  return { columns, stacks, movedCount };
}
